// extracted by mini-css-extract-plugin
export default {"table":"Transactions_table__okeH+","thead":"Transactions_thead__NmHeY"};